import React from 'react'
import styles from './AggregationValue.module.scss'
import { AggregationValueProps } from './types'
import cl from 'classnames'

const AggregationValueComponent = (props: AggregationValueProps) => {
  const { value, entity = 'unit', showFrame } = props

  if (!value) return null

  const entityLabel = value === 1
    ? entity
    : `${entity}s`

  return (
    <div className={cl(styles.container, { [styles.frame]: showFrame })}>
      {value} {entityLabel}
    </div>
  )
}

const AggregationValue = AggregationValueComponent
export { AggregationValue }
